export type CheckoutV2Features = {
  displayRpd?: boolean
  // utile pour le petit HT à coté du prix HT
  displayMention?: boolean
  selectionByProducts?: boolean
  hasAddOns?: boolean
  hasPickupPointFree?: boolean
  blockAddressForPricerOffer?: boolean
  displayToBeCalulated?: boolean
  displayCutOffMessage?: boolean
}

export type Features = {
  home: {
    advantages: boolean
    contactTechnicalSale?: boolean
  }
  certificates: {
    phyto: boolean
    explosive: boolean
  }
  contact: {
    mailTo?: string
    hubspot?: {
      formId: string
      portalId: string
    }
  }
  shoppingList: boolean
  header: {
    leftEntries?: Array<{
      name: string
      path: string
    }>
    loggedInLogo?: string
    secondaryLogo?: string
    showDistributor?: boolean
  }
  footer: {
    logo?: string
    sponsor?: {
      config: {
        logo: string
        altText: string
        homePageUrl: string
      }
    }
    social?: {
      facebook?: string
      linkedin?: string
      x?: string
      youtube?: string
      instagram?: string
    }
    apps?: {
      iOS?: string
      Android?: string
    }
    legals: {
      termsOfUse?: LegalLink
      personalData?: LegalLink
      termsOfSale?: LegalLink
      cookiePolicy: LegalLink
      legalNotice?: LegalLink
    }
    languagePicker: boolean
  }
  pdp: {
    templateB2AGFeature: boolean
    showOnlyMainImage: boolean
    showSupplier: boolean
    showSupplierUniverseLink?: boolean
    showBenefits?: boolean
    showCarouselSupplier?: boolean
  }
  plp: {
    offSeasonBadge: boolean
  }
  equalWeb: boolean
  clickDimensions: boolean
  checkoutV2: CheckoutV2Features
  // Pays (ISO 3166-1 alpha-2, majuscules) pour lesquels le mode SIRET du parcours signup
  // appelle effectivement le registre d'entreprises via le BFF. Hors de cette liste, le
  // lookup est skippé et l'utilisateur saisit manuellement les infos société.
  // ⚠️ N'ajouter un pays ici que si le BFF supporte effectivement son registre (sinon
  // appel qui échoue → UX "SIRET invalide" parasite).
  registryLookup: {
    enabledCountries: string[]
  }
  axeptio?: {
    i18n?: {
      cases: {
        default: string
        [key: string]: string
      }
    }
  }
  customer?: {
    associatedAccounts?: {
      dissociationLabelIdentifier?: string
    }
  }
  myAccount?: {
    profile: {
      shouldHideCountry: boolean
    }
  }
  server: {
    currentTheme: {
      canBeChangeAtRuntime: boolean
      partnerThemesList?: Map<string, string>
    }
  }
  seo: {
    useDescriptionFromProduct: boolean
  }
  newsletter?: {
    hubspot?: {
      formId: string
      portalId: string
    }
    showCard?: boolean
  }
  platform: {
    name: string
  }
  inLanguage: 'fr-FR' | 'en-US'
  webSite: {
    name: string
    url: string
    searchTargetUrl: string
  }
}

export type HomeAnchor = {
  label: string
  selector: string
  hideLink: boolean
}

export type LegalLink = {
  label: string
  linksTo?: {
    name: string
  }
  click?: () => void
  tag: 'a' | 'button' | 'router-link'
}

export const allFeaturesAtFalse: Features = {
  home: {
    advantages: false,
    contactTechnicalSale: false,
  },
  certificates: {
    phyto: false,
    explosive: false,
  },
  contact: {
    mailTo: '',
  },
  shoppingList: false,
  header: {
    showDistributor: false,
  },
  footer: {
    legals: {
      termsOfUse: { label: `Conditions Générales d'Utilisation`, linksTo: { name: 'legals' }, tag: 'router-link' },
      personalData: { label: `Données personnelles`, linksTo: { name: 'privacy' }, tag: 'router-link' },
      termsOfSale: { label: `Conditions générales de vente`, linksTo: { name: 'cgv' }, tag: 'router-link' },
      cookiePolicy: { label: `Paramétrer les cookies`, click: () => { }, tag: 'button' },
      legalNotice: { label: `Mentions légales`, linksTo: { name: 'legal-notice' }, tag: 'router-link' },
    },
    languagePicker: false,
  },
  pdp: {
    templateB2AGFeature: false,
    showOnlyMainImage: false,
    showSupplier: false,
    showSupplierUniverseLink: false,
    showBenefits: false,
    showCarouselSupplier: false,
  },
  plp: {
    offSeasonBadge: false,
  },
  equalWeb: false,
  clickDimensions: false,
  checkoutV2: {
    displayRpd: false,
    displayMention: false,
    selectionByProducts: false,
    blockAddressForPricerOffer: false,
    displayToBeCalulated: false,
    displayCutOffMessage: false,
  },
  registryLookup: {
    enabledCountries: ['FR'],
  },
  server: {
    currentTheme: {
      canBeChangeAtRuntime: false,
    },
  },
  seo: {
    useDescriptionFromProduct: false,
  },
  platform: {
    name: '',
  },
  inLanguage: 'fr-FR',
  webSite: {
    name: '',
    url: '',
    searchTargetUrl: '',
  },
}
